﻿/*  --------------------------------------
  assets/z_variant-picker-wccg-related.js
  Version  1.0.0 Build 001  (21-05-2026)
  Lines: 139
  --------------------------------------------------------
*/

(function() {
  var W = window.WCCG;
  if (!W || !W.picker) return;

  function log(msg, data) {
    if (data !== undefined) console.log('[' + W.name + ':related] ' + msg, data);
    else console.log('[' + W.name + ':related] ' + msg);
  }

  log('module loaded');

  var config = window.WCCG_related;
  if (!config || config.length === 0) {
    log('No related products configured (window.WCCG_related)');
    return;
  }

  /* Saml alle variant-IDs fra pickeren */
  var pickerVariantIds = [];
  W.inputs.forEach(function(input) {
    var vid = input.dataset.variantId;
    if (vid && pickerVariantIds.indexOf(vid) === -1) {
      pickerVariantIds.push(vid);
    }
  });

  log('Picker variant IDs:', pickerVariantIds);

  /* Filtrér relaterede produkter baseret på triggerIds */
  var matched = config.filter(function(rp) {
    if (!rp.triggerIds) return true;
    return rp.triggerIds.some(function(tid) {
      return pickerVariantIds.indexOf(String(tid)) !== -1;
    });
  });

  if (matched.length === 0) {
    log('No related products match picker variant IDs');
    return;
  }

  log(matched.length + ' related product(s) matched');

  /* Tjek lagerbeholdning — fjern udsolgte */
  var inv = window.WCCG_inventory || {};
  var available = matched.filter(function(rp) {
    var v = inv[String(rp.variantId)];
    if (!v) {
      log('  ' + rp.title + ' — no inventory data, assumed available');
      return true;
    }
    if (!v.inventory_management || v.inventory_management === null) {
      log('  ' + rp.title + ' — no tracking, available');
      return true;
    }
    if (v.inventory_policy === 'continue') {
      log('  ' + rp.title + ' — sells when OOS, available');
      return true;
    }
    if (!v.available || (v.inventory_quantity !== null && v.inventory_quantity <= 0)) {
      log('  ' + rp.title + ' — SOLD OUT, hiding');
      return false;
    }
    log('  ' + rp.title + ' — in stock (' + v.inventory_quantity + ')');
    return true;
  });

  if (available.length === 0) {
    log('All related products sold out');
    return;
  }

  /* Render relaterede produkter */
  var container = W.picker.querySelector('[data-wccg-related]');
  var list = W.picker.querySelector('[data-wccg-related-list]');
  if (!container || !list) {
    log('Related products container not found in DOM');
    return;
  }

  available.forEach(function(rp) {
    var html = '<div class="wccg-vp__rel-item" data-wccg-rel-vid="' + rp.variantId + '">'
      + '<img src="' + rp.image + '" alt="' + rp.title + '" class="wccg-vp__rel-img" width="40" height="40" loading="lazy">'
      + '<div class="wccg-vp__rel-info">'
      + '<div class="wccg-vp__rel-title">' + rp.title + '</div>'
      + '<div class="wccg-vp__rel-meta">'
      + '<span class="wccg-vp__rel-price">' + rp.price + '</span>'
      + '<a href="' + rp.url + '" target="_blank" class="wccg-vp__rel-link">L\u00e6s mere</a>'
      + '</div>'
      + '</div>'
      + '<div class="wccg-vp__rel-qty" data-wccg-rel-stepper>'
      + '<button type="button" class="wccg-vp__rel-qty-btn" data-wccg-rel-minus>\u2212</button>'
      + '<span class="wccg-vp__rel-qty-val" data-wccg-rel-val>0</span>'
      + '<button type="button" class="wccg-vp__rel-qty-btn" data-wccg-rel-plus>+</button>'
      + '</div>'
      + '</div>';
    list.insertAdjacentHTML('beforeend', html);
  });

  container.style.display = '';
  log(available.length + ' related product(s) rendered');

  /* Event delegation for plus/minus */
  list.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wccg-rel-minus], [data-wccg-rel-plus]');
    if (!btn) return;
    e.preventDefault();

    var stepper = btn.closest('[data-wccg-rel-stepper]');
    var valEl = stepper ? stepper.querySelector('[data-wccg-rel-val]') : null;
    if (!valEl) return;

    var current = parseInt(valEl.textContent) || 0;
    if (btn.hasAttribute('data-wccg-rel-minus')) {
      current = Math.max(0, current - 1);
    } else {
      current = current + 1;
    }
    valEl.textContent = current;
  });

  /* Eksponér getRelatedItems() så cart.js kan bruge den */
  W.getRelatedItems = function() {
    var items = [];
    var relItems = list.querySelectorAll('[data-wccg-rel-vid]');
    relItems.forEach(function(el) {
      var valEl = el.querySelector('[data-wccg-rel-val]');
      var qty = valEl ? parseInt(valEl.textContent) || 0 : 0;
      if (qty > 0) {
        var vid = el.dataset.wccgRelVid;
        items.push({ id: parseInt(vid), quantity: qty });
      }
    });
    return items;
  };

  log('getRelatedItems() exposed on window.WCCG');
})();
